import React from 'react'
import {
  Button,
  Form,
  Input,
  Select,
} from 'antd'
import { DeleteFilled } from '@ant-design/icons'
import {
  MANAGER,
  APPRAISER,
} from '@components/Signup/constants'

const { Option } = Select

const labelCol = { span: 24 }

const CompanyMember = ({
  email,
  index,
  removeCompanyMember,
  role,
  validEmailToInvite,
}) => {
  return (
    <div className='company-member-form'>
      <Form.Item
        className='role'
        label='Role'
        labelCol={labelCol}
        name={`role_${email || index}`}
        initialValue={role || APPRAISER}
      >
        <Select
          defaultActiveFirstOption={true}
          name={`role_${email || index}`}
          disabled={!index}
        >
          <Option value={APPRAISER}>Appraiser</Option>
          <Option value={MANAGER}>Manager</Option>
        </Select>
      </Form.Item>
      <Form.Item
        className='email'
        label='Email'
        labelCol={labelCol}
        name={`email_${email || index}`}
        rules={[
          {
            type: 'email',
            message: 'Please enter a valid email',
          },
          () => ({
            validator(_, value) {
              if (email || validEmailToInvite(value)) {
                return Promise.resolve()
              }
              return Promise.reject(new Error('This user has already been invited'))
            },
          }),
        ]}
        initialValue={email}
      >
        <Input
          type='email'
          name={`email_${email || index}`}
          disabled={!index}
        />
      </Form.Item>
      {index > 0 && removeCompanyMember
        ? (
        <Button
          type='text'
          onClick={() => removeCompanyMember(index)}
        >
          <DeleteFilled
            style={{ color: '#cd201f', fontSize: '20px' }}
          />
        </Button>
          )
        : <div className='empty'/>}
    </div>
  )
}

export default CompanyMember
